import { useState } from "react";
import { Check, ChevronsUpDown, X } from "lucide-react";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { PlanBadge } from "./ui";

/** One plan → one Stax Bill plan product (searchable). */
export function ProductPicker({ plan, products, value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const cur = products.find((p) => p.id === value);
  return (
    <div className="flex items-center gap-2">
      <PlanBadge plan={plan} />
      <span className="w-32 shrink-0 text-xs font-medium text-slate-600">{plan}</span>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid}
                  className="flex h-9 min-w-0 flex-1 items-center justify-between gap-2 rounded-md border border-slate-200 bg-white px-3 text-left text-sm hover:border-slate-300">
            <span className={`truncate ${cur || value ? "text-slate-800" : "text-slate-400"}`}>
              {cur ? `${cur.name} · ${cur.code}` : value ? `Product ${value}` : "No product for this plan"}</span>
            <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-slate-400" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[460px] p-0" align="start">
          <Command>
            <CommandInput placeholder={`Search ${plan} products…`} data-testid={`${testid}-search`} />
            <CommandList className="max-h-72">
              <CommandEmpty>No product found.</CommandEmpty>
              <CommandGroup>
                {products.map((p) => (
                  <CommandItem key={p.id} value={`${p.name} ${p.code} ${p.id}`} onSelect={() => { onChange(p.id); setOpen(false); }}
                               data-testid={`${testid}-opt-${p.id}`}>
                    <Check className={`h-3.5 w-3.5 ${p.id === value ? "opacity-100" : "opacity-0"}`} />
                    <span className="flex-1 truncate">{p.name}</span>
                    <span className="font-mono text-[10px] text-slate-400">{p.code} · {p.id}</span>
                    {p.status === "Retired" && <span className="rounded bg-slate-100 px-1 text-[10px] text-slate-500">retired</span>}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <button type="button" onClick={() => onChange("")} disabled={!value} title="Remove"
              className="rounded p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700 disabled:opacity-30" data-testid={`${testid}-clear`}>
        <X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
